import { useState, useRef, useEffect } from 'react';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import Style from "./css/style.module.css";
import strFunc from '@/lib/lyg/string';
import ArrFunc from '@/lib/lyg/arr_func';

function SelectCGWordArrPopupArea(props: any) {
  let myProps = {
    closePopup: () => { },
    refreshData: (inData: any) => { },
    callbackData: (inData: any) => { },
    cg_word_arr: [],
    cg_word_pri_val_arr: [],
    select_cg_word_pri_val_arr: [],
    voice: "",
    ...props
  };
  const WordAudioRef = useRef<any>(null);
  const [cg_word_arr, set_cg_word_arr] = useState<any>(myProps.cg_word_arr);
  const [select_cg_word_pri_val_arr, set_select_cg_word_pri_val_arr] = useState<any>([...myProps.select_cg_word_pri_val_arr]);
  const [select_option, set_select_option] = useState<any>({
    random_select_cnt: myProps.select_cg_word_pri_val_arr.length != 0 ? Math.floor(myProps.select_cg_word_pri_val_arr.length / 3) : 0,
  });

  useEffect(() => {
    if (myProps.cg_word_pri_val_arr.length > 0 && myProps.cg_word_arr.length == 0) {
      get_cg_word_by_ajax();
    }
  }, [myProps.cg_word_pri_val_arr]);

  const get_cg_word_by_ajax = () => {
    let cg_word_pri_val_arr = [];
    if (myProps.cg_word_pri_val_arr && myProps.cg_word_pri_val_arr.length > 0) {
      for (let i = 0; i < myProps.cg_word_pri_val_arr.length; i++) {
        let row_pri_val = myProps.cg_word_pri_val_arr[i];
        if (!strFunc.is_empty(row_pri_val)) {
          cg_word_pri_val_arr.push(row_pri_val);
        }
      }
    }
    if (cg_word_pri_val_arr.length == 0) {
      return false;
    }
    let tmp_list_opt: any = {
      s_pri_arr: cg_word_pri_val_arr,
      s_mcomp_seq: "",
      order_id: "a_order_num",
      s_addon_word_file: "1",
      // s_addon_word_file_voice: myProps.voice,
      is_paging: "",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/coolen/group_word/list',
      tmp_list_opt, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          set_cg_word_arr(response.data["data"]["info_arr"]);
        } else {

        }
      });
  };

  const select_complete = () => {
    let select_cg_word_arr: any = [];
    for (let i = 0; i < cg_word_arr.length; i++) {
      let row_pri_val = cg_word_arr[i].row_pri_val;
      if (strFunc.str_in_array(row_pri_val, select_cg_word_pri_val_arr) != -1) {
        select_cg_word_arr.push(cg_word_arr[i]);
      }
    }
    myProps.callbackData({
      info_arr: select_cg_word_arr,
    });
    myProps.closePopup();
  };

  const on_change_check_all = (inData: any) => {
    let checked = inData.target.checked;
    if (checked) {
      let change_select_cg_word_pri_val_arr = [];
      for (let i = 0; i < cg_word_arr.length; i++) {
        let row_pri_val = cg_word_arr[i].row_pri_val;
        change_select_cg_word_pri_val_arr.push(row_pri_val);
      }
      set_select_cg_word_pri_val_arr(change_select_cg_word_pri_val_arr);
    } else {
      set_select_cg_word_pri_val_arr([]);
    }
  };

  const on_change_row_checked = (inData: any) => {
    let opt_obj = {
      info: null,
      is_checked: false,
      ...inData
    };
    let info = opt_obj.info;
    let is_checked = opt_obj.is_checked;

    if (is_checked) {
      let change_select_cg_word_pri_val_arr = [...select_cg_word_pri_val_arr];
      if (strFunc.str_in_array(info.row_pri_val, select_cg_word_pri_val_arr) == -1) {
        change_select_cg_word_pri_val_arr.push(info.row_pri_val);
      }
      set_select_cg_word_pri_val_arr(change_select_cg_word_pri_val_arr);
    } else {
      let change_select_cg_word_pri_val_arr = [];
      for (let i = 0; i < select_cg_word_pri_val_arr.length; i++) {
        let row_pri_val = select_cg_word_pri_val_arr[i];
        if (row_pri_val != info.row_pri_val) {
          change_select_cg_word_pri_val_arr.push(row_pri_val);
        }
      }
      set_select_cg_word_pri_val_arr(change_select_cg_word_pri_val_arr);
    }
  };

  const go_random_select = () => {
    let random_select_cnt = select_option.random_select_cnt;
    if (random_select_cnt == 0) {
      set_select_cg_word_pri_val_arr([]);
      return false;
    }

    let new_select_arr = ArrFunc.get_random_idx_pick_arr(cg_word_arr, random_select_cnt);
    let new_select_pri_val_arr = [];
    for (let i = 0; i < new_select_arr.length; i++) {
      let row_pri_val = new_select_arr[i].row_pri_val;
      new_select_pri_val_arr.push(row_pri_val);
    }
    set_select_cg_word_pri_val_arr(new_select_pri_val_arr);
  };

  const get_cg_word_tags = () => {
    let cg_word_tags = cg_word_arr.map((item: any, idx: number) => {
      let is_checked = false;
      if (strFunc.str_in_array(item.row_pri_val, select_cg_word_pri_val_arr) != -1) {
        is_checked = true;
      }
      const row_click = () => on_change_row_checked({ info: item, is_checked: !is_checked });
      return (
        <tr key={idx} className={is_checked ? Style.row_checked : ""}>
          <td className={Style.td_check} onClick={row_click}>
            <input type='checkbox' checked={is_checked} name="row_checked"
              onChange={() => { }} />
          </td>
          <td className={Style.td_num} onClick={row_click}>{idx + 1}</td>
          <td className={Style.td_word} onClick={row_click}>{item.a_word}</td>
          <td className={Style.td_mean} onClick={row_click}>{item.a_mean}</td>
          <td className={Style.td_mp3}>
            <button className={Style.btn_mp3}
              onClick={() => {
                if (item.word_file_info && item.word_file_info.img_url) {
                  if (WordAudioRef.current) {
                    WordAudioRef.current.src = item.word_file_info.img_url;
                    WordAudioRef.current.play();
                  }
                }
              }}
            >mp3</button>
          </td>
        </tr>
      );
    });

    return cg_word_tags;
  };

  return (
    <div className={Style.wrap}>
      <div className={Style.btn_area}>
        <button className={Style.btn_complete} onClick={() => { select_complete(); }}>선택완료</button>
        <button className={Style.btn_close} onClick={() => { myProps.closePopup(); }}>닫기</button>
      </div>
      <div className={Style.toolbar}>
        <span className={Style.toolbar_label}>랜덤선택</span>
        <input className={Style.toolbar_input}
          type='text' value={strFunc.comma(select_option.random_select_cnt)} name="random_select_cnt"
          onChange={(e: any) => {
            let value = e.target.value;
            value = parseInt(strFunc.uncomma(value));
            if (value > cg_word_arr.length) { value = cg_word_arr.length; }
            if (value < 0) { value = 0; }
            set_select_option({ ...select_option, random_select_cnt: value });
          }}
        />
        <button className={Style.btn_random} onClick={() => { go_random_select(); }}>랜덤선택</button>
      </div>
      <div className={Style.info_row}>
        <label className={Style.check_all_label}>
          <input type='checkbox' onChange={on_change_check_all} />
          전체선택
        </label>
        <span className={Style.count_text}>
          선택단어 <span>{select_cg_word_pri_val_arr.length}</span> / {cg_word_arr.length}
        </span>
      </div>
      <div className={Style.table_wrap}>
        <table className={Style.word_table}>
          <thead>
            <tr>
              <th className={Style.td_check}></th>
              <th className={Style.td_num}>#</th>
              <th>단어</th>
              <th>뜻</th>
              <th className={Style.td_mp3}></th>
            </tr>
          </thead>
          <tbody>
            {get_cg_word_tags()}
          </tbody>
        </table>
      </div>
      <div className={Style.btn_area}>
        <button className={Style.btn_complete} onClick={() => { select_complete(); }}>선택완료</button>
        <button className={Style.btn_close} onClick={() => { myProps.closePopup(); }}>닫기</button>
      </div>
      <div style={{ display: "none" }}>
        <audio id="audio_player" ref={WordAudioRef} src="" ></audio>
      </div>
    </div>
  );
};
export default SelectCGWordArrPopupArea;